<template>
    <div class="tutor-apply">
        <el-dialog
            title="导师申请"
            :visible.sync="showtutorapplypicker"
            width="1200px"
            append-to-body
            :before-close="handelclose">
            <div class="base-warp">
                <div class="head">
                    <el-form :model="form" label-width="40px" :inline="true" size="mini">
                        <el-form-item label="姓名">
                            <el-input v-model="form.name" placeholder="请输入导师姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="电话">
                            <el-input v-model="form.telephone" placeholder="请输入导师电话"></el-input>
                        </el-form-item>
                        <el-form-item label="状态">
                            <el-select v-model="form.status" value-key="" placeholder="请选择审核是否通过" clearable filterable>
                                <el-option label="已通过" value="已通过"></el-option>
                                <el-option label="不通过" value="不通过"></el-option>
                                <el-option label="待审核" value="待审核"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="search" icon="el-icon-search">搜索</el-button>
                        </el-form-item>
                    </el-form>
                </div>

                <div class="table-box">
                    <el-table 
                    :data="tutors" 
                    border 
                    stripe
                    size="mini"
                    :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}">
                        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                        <el-table-column prop="name" label="头像" align="center">
                            <template slot-scope="s">
                                <el-popover
                                    placement="top-start"
                                    width="200"
                                    trigger="hover">
                                    <el-image class="ltpic" :src="s.row.ltpic.url" fit="scale-down"></el-image>
                                    <el-avatar class="avatar" slot="reference" icon="el-icon-user-solid" size="large" shape="circle" :src="s.row.ltpic.url" fit="cover"></el-avatar>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="姓名" align="center"></el-table-column>
                        <el-table-column prop="telephone" label="电话" align="center"></el-table-column>
                        <el-table-column prop="email" label="邮箱" align="center"></el-table-column>
                        <el-table-column prop="addDate" label="申请时间" align="center"></el-table-column>
                        <el-table-column prop="addDate" label="关联用户" align="center"></el-table-column>
                        <el-table-column label="操作" align="center" width="260">
                            <template slot-scope="s">
                                <el-button-group>
                                    <el-button type="primary" size="mini" plain icon="el-icon-edit-outline">详情</el-button>
                                    <el-button v-if="s.row.status=='01'" type="success" size="mini" icon="el-icon-check" @click="setapplystatus(s.row, '03')">通过</el-button>
                                    <el-button v-if="s.row.status=='01'" type="danger" size="mini" icon="el-icon-close"  @click="setapplystatus(s.row, '04')">不通过</el-button>
                                </el-button-group>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination class="page-tion"
                    @current-change="currentChange"
                    layout="prev, pager, next"
                    :page-size="pagesize"
                    :total="total" background>
                </el-pagination>
            </div>
            
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'TutorApplyList',
    data() {
        return {
            form: {
                name: '',
                telephone: '',
                status: '',
            },
            tutors: [1],
            pageNo: 1,
            pagesize: 10,
            total: 0,
        }
    },
    computed: {
        showtutorapplypicker: {
            get() {
                return this.$store.getters.gettutorapplypicker;
            },
            set(value) {
                this.$store.commit('settutorapplypicker', value);
            },
        }
    },
    mounted () {
        this.getData();
    },
    methods: {
        setapplystatus(item, status) {
            var params = {
                id: item._id['$oid'],
                status
            }
            this.$api.settutorapplystatus(params).then(
                data=>{
                    this.$message.success(data);
                    this.getData();
                }
            )
        },
        currentChange(page) {
            this.pageNo = page;
            this.getData();
        },
        getData() {
            var params = {
                name: this.form.name,
                telephone: this.form.telephone,
                status: this.form.status,
                pageNo: this.pageNo,
                pagesize: this.pagesize
            }
            this.$api.gettutorapplyList(params).then(
                data=>{
                    let {list, total} = data;
                    this.tutors = list;
                    this.total = total;
                }
            )
        },
        handelclose() {
            this.$store.commit('settutorapplypicker', false);
        },
        search() {
            this.pageNo = 1;
            this.getData();
        },
    },
}
</script>

<style lang="scss" scoped>

</style>